import {AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CalendarComponent} from 'ng-fullcalendar';
import {EventDetailSetting} from '../../models/event-detail-setting';
import {SharedValueService} from '../../services/shared-value.service';
import {EventService} from '../../services/event.service';
import {DialogService} from '../../services/dialog.service';
import {Options} from 'fullcalendar';
import {RoomSetting} from '../../models/room-setting';
import 'jqueryui';
import * as moment from 'moment';
import {CreatedEventSettings} from '../../models/created-event-settings';
import {GroupSetting} from '../../models/group-setting';
import {UserSetting} from '../../models/user-setting';
import 'jquery-datetimepicker';
import {BUTTON_NAME, EVENT_RECURSIVE_OPTIONS, TypeRoom} from '../../common/constants';
import {AllEventsSetting} from '../../models/all-events-setting';
import {NotifierService} from 'angular-notifier';
import {RoomService} from '../../services/room.service';
import {GroupService} from '../../services/group.service';
import {DialogResult} from '../../models/dialog-param';
import {ActivatedRoute} from '@angular/router';
import {Observable, Subscription} from 'rxjs/Rx';
import {Helper} from '../../common/helper';
import {SiteSetting} from '../../models/site-setting';
import {SiteService} from '../../services/site.service';
import {AuthenticationService} from '../../services/authentication.service';
import {UserService} from '../../services/user.service';
declare const $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  preserveWhitespaces: false
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  public TypeRoom: typeof TypeRoom = TypeRoom;
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
  calendarOptions: Options;
  originRooms: RoomSetting[] = [];
  rooms: RoomSetting[] = [];
  groups: GroupSetting[] = [];
  sites: SiteSetting[] = [];
  select2Option: Select2Options;
  select2Data: any[];
  initSiteIds: string[];
  selectedSiteIds: string[];
  searchSiteIds: string[];
  listEvents = [];
  originalListEvents = [];
  userSession: UserSetting;
  retryTime = 1000;
  recursive_options: typeof EVENT_RECURSIVE_OPTIONS = EVENT_RECURSIVE_OPTIONS;
  clickedRoomName: string;
  clickedRoom: any;
  isLoading = false;
  timerSubscription: Subscription;
  groupSubscription: Subscription;
  roomSubscription: Subscription;
  siteSubscription: Subscription;
  private initial = true;
  displayedDate: any;

  constructor(private eventService: EventService,
              private sharedValueService: SharedValueService,
              private dialogService: DialogService,
              private notifierService: NotifierService,
              private roomService: RoomService,
              private groupService: GroupService,
              private siteService: SiteService,
              private userService: UserService,
              private auth: AuthenticationService,
              private activatedRoute: ActivatedRoute,
              private ngZone: NgZone,
              private helper: Helper,
              private changeDetectorRef: ChangeDetectorRef) {
    this._setSelect2Init();
  }

  private _setSelect2Init() {
    this.select2Option = {
      multiple: true,
      allowClear: true,
      placeholder: 'Site...',
      tokenSeparators: [',', ' '],
    };
  }

  ngOnInit() {
    this.clearDateTimePicker();
    this.sharedValueService.fetchUserSession().subscribe((res) => {
      // get user session
      this.userSession = this.sharedValueService.getUserSession();
    });
    this.helper._unsubsribe(this.groupSubscription);
    this.helper._unsubsribe(this.roomSubscription);
    this.roomSubscription = this.roomService.getAllRooms().subscribe(list => {
      this.rooms = list;
      this.originRooms = list;
      this._getInit();
    });
    this.groupSubscription = this.groupService.getAllGroups().subscribe(gr => {
      this.groups = gr;
    });

    this.siteSubscription = this.siteService.getAllSite().subscribe(sites => {
      this.sites = sites;
      this.select2Data = $.map(this.sites, function (obj) {
        return {id: obj.id, text: obj.name};
      });
    });

    this.userService.getSiteUser().subscribe(res => {
      this.initSiteIds = $.map(res, function (obj) {
        return obj.id.toString();
      });
    });

    let interval = setInterval(() => {
      if (!this.userSession) {
          this.userSession = this.sharedValueService.getUserSession();
      } else {
        clearInterval(interval);
        interval = null;
      }
    }, this.retryTime);

    this._calendarInit();
  }

  ngAfterViewInit() {
    this.helper._unsubsribe(this.timerSubscription);
    // run every 5 minutes to get lists of events
    this.ngZone.runOutsideAngular(() => {
        this.timerSubscription = Observable.timer(0, 300000).subscribe(i => {
          if (this.ucCalendar && !this.initial) {
            this.ngZone.run(() => {
              this.reloadCalendar();
            });
          }
        });
    });
    (<any>$('#startDatetime')).datetimepicker({
      format: 'Y-m-d H:00',
      minDate: new Date(),
      allowTimes: this._getAllowTimes(),
      onShow: function(ct) {
        this.setOptions({
          maxDate: $('#endDatetime').val() ? $('#endDatetime').val() : false
        });
      },
      defaultTime: moment().format('HH:00'),
    });


    (<any>$('#endDatetime')).datetimepicker({
      format: 'Y-m-d H:00',
      allowTimes: this._getAllowTimes(),
      defaultTime: moment().add('1', 'hour').format('HH:00'),
      onShow: function(ct) {
        this.setOptions({
          minDate: $('#startDatetime').val() ? $('#startDatetime').val() : new Date(),
        });
      },
    });
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.timerSubscription);
    this.helper._unsubsribe(this.groupSubscription);
    this.helper._unsubsribe(this.roomSubscription);
    this.helper._unsubsribe(this.siteSubscription);
    this.clearDateTimePicker();
  }

  private _getAllowTimes() {
    const arrTime = [];
    for (let i = 8; i <= 19; i++) {
      for (let j = 0; j < 60; j += 60) {
        let a = '';
        if (i < 10) {
          if (j < 10) {
            a = '0' + i.toString() + ':0' + j.toString();
          } else {
            a = '0' + i.toString() + ':' + j.toString();
          }
        } else {
          if (j < 10) {
            a = i.toString() + ':0' + j.toString();
          } else {
            a = i.toString() + ':' + j.toString();
          }
        }
        arrTime.push(a);
      }
    }
    return arrTime;
  }

  private _calendarInit() {
    this.calendarOptions = {
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultView: 'agendaWeek',
      allDaySlot: false,
      slotLabelFormat: 'HH:mm',
      slotDuration: moment.duration(15, 'minutes'),
      minTime: moment.duration(8, 'hour'),
      maxTime: moment.duration(19, 'hour'),
      editable: true,
      selectable: true,
      eventLimit: false,
      slotEventOverlap: false,
      height: 'parent',
      loading: ( isLoading) => {
        if (isLoading) {
          this.isLoading = isLoading;
        } else {
          setTimeout(() => {
            this.isLoading = isLoading;
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            }
          }, 500);
        }
      },
      views: {
        month: {
          timeFormat: 'H:mm'
        },
        agendaWeek: {
          timeFormat: 'H:mm'
        },
        agendaDay: {
          timeFormat: 'H:mm'
        }
      },
      eventSources: [
        {
          events: (start, end, timezone, callback) => {
            this.ucCalendar.fullCalendar('removeEvents');
            const _startDate = moment(start).format('YYYY-MM-DD');
            const _endDate = moment(end).add(-1, 'days').format('YYYY-MM-DD');
            this.eventService.getAllEvents(_startDate, _endDate).subscribe(list => {
              setTimeout(() => {
                this.isLoading = false;
              });
              this.initial = false;
              this.originalListEvents = this.convertEvents(list);
              this.filterEventsByRoom(this.clickedRoom);
              callback(this.listEvents);
            }, error => {
              this.initial = false;
              setTimeout(() => {
                this.isLoading = false;
              });
            });
          },
        }
      ]
    };
  }

  private _getInit() {
    this.activatedRoute.fragment
      .subscribe( fragment => {
        if (fragment) {
          const rooms = this.rooms.filter(r => r.r_name === fragment).map((obj) => {
            return obj;
          });
          if (rooms.length) {
            this.clickedRoom = rooms[0];
            this.clickedRoomName = this.clickedRoom.r_name;
            if (this.originalListEvents.length) {
              this.listEvents = this.originalListEvents.filter(item => item.room_id === this.clickedRoom.id);
            }
          }
        }
      });
  }

  filterRoomBySite(data: {value: any[]}) {
    this.selectedSiteIds = data.value;

    if (this.initSiteIds) {
      // setting site user
      this.userService.settingSiteUser({siteIds: this.selectedSiteIds}).subscribe();
    }

    // filter rooms
    if (this.selectedSiteIds.length) {
      this.rooms = this.originRooms.filter(room => {
        return this.selectedSiteIds.findIndex(siteId => siteId == room.site_id) !== -1;
      });
    } else {
      this.rooms = this.originRooms;
    }

    // filter events
    let clickedRoom = null;
    if (this.clickedRoom) {
      const index = this.rooms.findIndex(room => room.id === this.clickedRoom.id);
      clickedRoom = index !== -1 ? this.clickedRoom : null;
    }
    this.filterEventsByRoom(clickedRoom);
  }

  filterEventsByRoom(room?: any) {
    if (room) {
      this.clickedRoom = room;
      if (room.type_room === TypeRoom.VIP && !this.userSession.authority.AU_1) {
        this.clickedRoomName = 'ALL';
        window.location.hash = this.clickedRoomName;
        this.listEvents = [...this.originalListEvents];
      } else {
        this.clickedRoomName = this.clickedRoom.r_name;
        window.location.hash = this.clickedRoomName;
        this.listEvents = this.originalListEvents.filter(item => item.room_id === room.id);
      }         
    } else {
      this.clickedRoom = null;
      this.clickedRoomName = 'ALL';
      window.location.hash = this.clickedRoomName;
      this.listEvents = this.originalListEvents.filter(item => {
        return this.rooms.findIndex(r => r.id === item.room_id) !== -1;
      });
    }
  }

  convertEvents(list: EventDetailSetting[]) {
    for (let i = 0; i < list.length; i++) {
      list[i].r_color = list[i].r_color ? list[i].r_color : this.sharedValueService.getColorByRoomId(list[i].room_id, this.rooms)[0];
      list[i]['backgroundColor'] = list[i].r_color;
      list[i]['borderColor'] = list[i].r_color;
      list[i]['title'] = list[i].summary;
      list[i]['textColor'] = 'white';
    }
    return list;
  }

  clickHeaderButton(model: any) {
    const _time = model.data;
    if (model.buttonType === 'next' || model.buttonType === 'prev' || model.buttonType === 'today') {
      this.displayedDate = moment(_time);
    }
    this.ucCalendar.fullCalendar('gotoDate', this.displayedDate);
  }

  onClickAddEventBtn() {
    const eventModel = new CreatedEventSettings();
    eventModel.start = moment().format('YYYY-MM-DD 08:00');
    eventModel.end = moment().format('YYYY-MM-DD 08:15');
    this.addEventPopup(eventModel);
  }

  selectEvent(model: any) {
    const eventModel = new CreatedEventSettings();
    eventModel.start = moment(model.start).format('YYYY-MM-DD HH:mm');
    eventModel.end = model.view.type === 'month' ? moment(model.end).add(-1, 'days').format('YYYY-MM-DD HH:mm') :
      moment(model.end).format('YYYY-MM-DD HH:mm');
    const currentDateTime = moment().format('YYYY-MM-DD HH:mm');
    if ((model.view.type !== 'month' && eventModel.start.toString() < currentDateTime.toString()) ||
      (model.view.type === 'month' && model.start.isBefore(moment(), 'day'))) {
      this.ucCalendar.fullCalendar('unselect');
      const html = '<div class="fs20 fw-400">Can\'t create events in the past.</div>';
      return this.dialogService.showMessage('Warning!', null, html,
        null, null, null, 'Close');
    } else {
      this.addEventPopup(eventModel);
    }
  }

  /**
   * update event popup
   * @param model
   * @param startTimeEvent
   */
  updateEvent(model: any, startTimeEvent?: string) {
    const currentDateTime = moment().format('YYYY-MM-DD HH:mm');
    const updatedModel = new EventDetailSetting();
    for (const prop in updatedModel) {
      if (model.event.hasOwnProperty(prop)) {
        if (prop === 'end' || prop === 'start') {
          updatedModel[prop] = moment(model.event[prop]).format('YYYY-MM-DD HH:mm:ss');
        } else {
          updatedModel[prop] = model.event[prop];
        }
      }
    }
    let html = '';
    if (this.userSession.isAdmin || this.userSession.isOwner || this.userSession.id === model.event.created_id_user) {
      // TO DO
    } else {
      html = '<div class="fs20 fw-400">You don\'t have permission for this action!</div>';
      return this.dialogService.showMessage('Warning!', null, html,
        null, null, null, 'Close').subscribe(res => {
        this.listEvents = [...this.originalListEvents];
      });
    }
    const _startTimeEdit = moment(model.event.start).format('YYYY-MM-DD HH:mm');
    const _startTimeEvent = startTimeEvent ? startTimeEvent : _startTimeEdit;

    if (_startTimeEvent < currentDateTime.toString() || _startTimeEdit < currentDateTime.toString()) {
      this.ucCalendar.fullCalendar('unselect');
      if (_startTimeEvent < currentDateTime.toString()) {
        html = '<div class="fs20 fw-400">Can\'t edit events in the past.</div>';
      } else {
        html = '<div class="fs20 fw-400"><div>Can\'t edit this event.</div><div>The editing time is invalid.</div></div>';
      }
      return this.dialogService.showMessage('Warning!', null, html,
        null, null, null, 'Close').subscribe(res => {
        this.listEvents = this.originalListEvents.filter(item => item.room_id === this.clickedRoom.id);
      });
    }
    this.dialogService.showUpdateEventDialog(updatedModel).subscribe((re: DialogResult) => {
      if (re.isOk()) {
        setTimeout(() => {
          this.dialogService.setLoaderVisible(true);
        });
        updatedModel['recursive_option'] = (re && re.payload['recursive_option']) ? re.payload['recursive_option'] :
          this.recursive_options.THIS;
        this.callApiUpdateEvent(model.event.id, updatedModel);
      } else {
        this.listEvents = [...this.originalListEvents];
      }
    });
  }

  /**
   * call Api update event
   * @param eventId
   * @param updatedModel
   */
  callApiUpdateEvent(eventId: number, updatedModel: any) {
    this.sharedValueService.waitingApiResponse.next(true);
    this.eventService.putUpdateEvent(eventId, updatedModel).subscribe(response => {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(false);
        this.notifierService.notify('success', response.message);
      });
      if (response.data && response.data.updated_events) {
        this.convertEvents(response.data.updated_events).forEach(event => {
          const index = this.originalListEvents.findIndex(item => item.id === event.id);
          this.originalListEvents[index] = event;
        });
      }
      if (response.data && response.data.deleted_event_ids) {
        response.data.deleted_event_ids.forEach(id => {
          this.originalListEvents = this.originalListEvents.filter(item => item.id !== id);
        });
      }
      if (response.data && response.data.added_events) {
        this.convertEvents(response.data.added_events).forEach(event => {
          this.originalListEvents = [...this.originalListEvents, event];
        });
      }

      if (this.clickedRoom) {
        this.listEvents = this.originalListEvents.filter(item => item.room_id === this.clickedRoom.id);
      } else {
        this.listEvents = [...this.originalListEvents];
      }
      this.sharedValueService.httpStatus.next(true);
    }, error => {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(false);
      });
      this.sharedValueService.httpStatus.next(false);
      this.listEvents = [...this.originalListEvents];
      const message = error.error.message ? error.error.message : 'Error occurred!';
      this.notifierService.notify('error', message);
    });
  }

  // click show detail popup
  eventClick(model: any) {
    setTimeout(() => {
      this.dialogService.setLoaderVisible(true);
    });
    this.eventService.getDetailEvent(model.event.id).subscribe(eventModel => {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(false);
      });

      const obj = {
        eventModel: eventModel,
        isAPICallError: false,
        checkValidate: true,
        isDetail: true
      };
      let deleteBtn = null;
      let updateBtn = null;
      let checkInBtn = null;
      const currentTime = moment().format('YYYY-MM-DD HH:mm');
      const eventDate = moment(model.event.start).format('YYYY-MM-DD HH:mm');
      if (this.userSession.isAdmin || this.userSession.isOwner || this.userSession.id === eventModel.created_id_user) {
        deleteBtn = 'Delete';
        updateBtn = eventDate >= currentTime ? 'Edit' : null;
      }
      if (this.userSession.id === eventModel.created_id_user) {
        const startCheckIn = moment(eventDate).subtract(15, 'minutes').format('YYYY-MM-DD HH:mm');
        const endCheckIn = moment(eventDate).add(15, 'minutes').format('YYYY-MM-DD HH:mm');
        if (moment(startCheckIn).isSameOrBefore(currentTime) && moment(endCheckIn).isSameOrAfter(currentTime)) {
          checkInBtn = 'Check In';
        }
      }
      this.showEvent(model.event.id, obj, updateBtn, deleteBtn, checkInBtn);
    }, error => {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(false);
      });
      const msg = error.error.message ? error.error.message : 'Error occurred!';
      this.notifierService.notify('error', msg);
    });
  }

  /**
   * show event info
   * @param id
   * @param obj
   * @param updateBtn
   * @param deleteBtn
   */
  showEvent(id, obj, updateBtn, deleteBtn, checkInBtn) {
    const modelEvent = Object.assign({}, obj);
    modelEvent.eventModel['eventId'] = id;

    this.dialogService.showEventModal('Event Info', updateBtn, null, deleteBtn, checkInBtn, 'Close', Object.assign({}, modelEvent))
      .subscribe((result: DialogResult) => {
        // UPDATE an event
        if (result.buttonName === BUTTON_NAME.OK) {
          const updatedModel = Object.assign(new CreatedEventSettings(), result.payload.eventModel);
          updatedModel.repeat_rule = result.payload.rrule;
          updatedModel.created_id_user = obj.eventModel.created_id_user;
          const reOpenParam = ['Event Info', updateBtn, null, deleteBtn, 'Close', obj];
          this.dialogService.showUpdateEventDialog(updatedModel, 'showEventModal', reOpenParam)
            .subscribe((re: DialogResult) => {
              if (re.isOk()) {
                setTimeout(() => {
                  this.dialogService.setLoaderVisible(true);
                });
                updatedModel['recursive_option'] = (re && re.payload['recursive_option']) ? re.payload['recursive_option'] :
                  this.recursive_options.THIS;
                this.callApiUpdateEvent(id, updatedModel);
              } else {
                this.showEvent(id, obj, updateBtn, deleteBtn, checkInBtn);
              }
            });
          // DELETE an event
        } else if (result.buttonName === BUTTON_NAME.DELETE) {
          const reOpenParam = ['Event Info', updateBtn, null, deleteBtn, 'Close', obj];
          this.dialogService.showDeleteEventDialog(obj.eventModel, 'showEventModal', reOpenParam).subscribe((re: DialogResult) => {
            if (re.isOk()) {
              setTimeout(() => {
                this.dialogService.setLoaderVisible(true);
              });
              const isDeleteAll = (re && re.payload['recursive_option']) ?
                re.payload['recursive_option'] === this.recursive_options.ALL : false;
              this.eventService.deleteEvent(id, isDeleteAll).subscribe(res => {
                setTimeout(() => {
                  this.notifierService.notify('success', res.message);
                });
                if (res.data && res.data.length > 0) {
                  res.data.forEach(eventId => {
                    this.originalListEvents = this.originalListEvents.filter(item => item.id !== eventId);
                  });
                  if (this.clickedRoom) {
                    this.listEvents = this.originalListEvents.filter(item => item.room_id === this.clickedRoom.id);
                  } else {
                    this.listEvents = [...this.originalListEvents];
                  }
                }
               setTimeout(() => {
                 (<any>$('.popover')).remove();
                 this.dialogService.setLoaderVisible(false);
               });
              }, error => {
                setTimeout(() => {
                  this.dialogService.setLoaderVisible(false);
                });
                const msg = error.error.message ? error.error.message : 'Error occurred!';
                this.notifierService.notify('error', msg);
              });
            } else {
              this.showEvent(id, obj, updateBtn, deleteBtn, checkInBtn);
            }
          });
        } else if (result.isCheckIn()) {

          setTimeout(() => {
            this.dialogService.setLoaderVisible(true);
          });
          this.eventService.checkInEvent(id).subscribe(
            (res) => {
              setTimeout(() => {
                this.dialogService.setLoaderVisible(false);
              });
              this.notifierService.notify('success', res.message);
            }, (error) => {
              setTimeout(() => {
                this.dialogService.setLoaderVisible(false);
              });
              const msg = error.error.message ? error.error.message : 'Error occurred!';
              this.notifierService.notify('error', msg);
            }
          );
        }

      });
  }

  showPopover(event: any) {
    const name = event.event.user_created ? event.event.user_created : 'Deleted Account';
    const content = '<div><div><b>Booker: </b>' + name + '</div>' +
      '<div><b>Start:</b> ' + moment(event.event.start).format('HH:mm YYYY-MM-DD') + '</div>' +
      '<div><b>End:</b> ' + moment(event.event.end).format('HH:mm YYYY-MM-DD ') + '</div></div>';
    setTimeout(() => {
      $(event.jsEvent.currentTarget).popover({
        placement: 'top',
        container: 'body',
        html: true,
        trigger: 'hover mouseover',
        title: event.event.summary,
        animation: false,
        content: () => {
          return content;
        }
      });
    });
  }

  changeSite(data: {value: any[]}) {
    this.searchSiteIds = data.value;
  }

  /**
   * search rooms empty
   * @param startElement
   * @param endElement
   */
  searchRoomsEmpty(startElement: HTMLInputElement, endElement: HTMLInputElement) {
    if (moment(startElement.value).isAfter(endElement.value)) {
      this.notifierService.notify('error', 'End time should be greater than start time!');
    } else {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(true);
      });
      const obj = {
        start:  moment(startElement.value).format('YYYY-MM-DD HH:mm'),
        end: moment(endElement.value).format('YYYY-MM-DD HH:mm'),
        siteIds: this.searchSiteIds
      };
      this.roomService.searchEmptyRooms(obj).subscribe((res) => {
        // this.clearDateTimePicker();
        setTimeout(() => {
          this.dialogService.setLoaderVisible(false);
        });
        const title = 'Search Rooms Empty ';
        let row = '';
        if (!Object.keys(res.data).length) {
          row = '<tr class="warning no-result"><td colspan="6"><i class="fa fa-warning"></i> No result</td></tr>';
        } else {
          Object.values(res.data).map(value => {
            row += `<tr><td>${value.r_name}</td><td>${value.r_size ? value.r_size : ''}</td>` +
              `<td><div class="color-column" style="background: ${value.color}"></div></td>` +
              `<td>` + (value.site_name ? value.site_name : '') + `</td></tr>`;
          });
        }
        const html = `<table class="table table-striped">
                          <thead>
                            <tr>
                              <th scope="col" class="text-center">Room Name</th>
                              <th scope="col" class="text-center">Room Size</th>
                              <th scope="col" class="text-center">Color</th>
                              <th scope="col" class="text-center">Site</th>
                            </tr>
                          </thead>
                        <tbody>${row}
                        </tbody>
                    </table>`;
        this.dialogService.showMessage(title, null, html, null, null, null, 'Close', 'modal-lg');
      }, error => {
        setTimeout(() => {
          this.dialogService.setLoaderVisible(false);
        });
        const msg = error.error.message ? error.error.message : 'Error occurred!';
        this.notifierService.notify('error', msg);
      });
    }
  }

  clearDateTimePicker() {
    (<any>$('#startDatetime')).val(null);
    (<any>$('#endDatetime')).val(null);
  }

  /**
   * Search events by summary
   * @param element
   */
  searchEvent(element: HTMLInputElement) {
    if (element.value) {
      setTimeout(() => {
        this.dialogService.setLoaderVisible(true);
      });
      const title =  'Search Event: ' + element.value;
      this.eventService.searchEvents(element.value).subscribe(res => {
        console.log(res);
        
        setTimeout(() => {
          this.dialogService.setLoaderVisible(false);
        });
        // element.value = '';
        let row = '';
        if (res.length) {
          res.forEach((item, index) => {
            row += `<tr><th scope="row">${index + 1}</th><td>${item.summary}</td><td>${moment(item.start).format('YYYY-MM-DD HH:mm')}</td>` +
                `<td>${moment(item.end).format('YYYY-MM-DD HH:mm')}</td><td>${item.r_name}</td>` +
                `<td>${item.g_name ? item.g_name : ''}</td>` +
                `<td>${item.siteName ? item.siteName : ''}</tr>`;
          });
        } else {
          row = '<tr class="warning no-result"><td colspan="12"><i class="fa fa-warning"></i> No result</td></tr>';
        }
        const html = `<table class="table table-striped">
                          <thead>
                            <tr>
                              <th scope="col" style="text-align: center">STT</th>
                              <th scope="col" style="text-align: center">Event Name</th>
                              <th scope="col" style="text-align: center">Start</th>
                              <th scope="col" style="text-align: center">End</th>
                              <th scope="col" style="text-align: center">Room</th>
                              <th scope="col" style="text-align: center">Group</th>
                              <th scope="col" style="text-align: center">Site</th>
                            </tr>
                          </thead>
                        <tbody>${row}
                        </tbody>
                    </table>`;
        this.dialogService.showMessage(title, null, html, null, null, null, 'Close', 'modal-lg');
      }, error => {
        setTimeout(() => {
          this.dialogService.setLoaderVisible(false);
        });
      });
    }
  }

  reloadCalendar() {
    this.ucCalendar.fullCalendar('refetchEvents');
  }

  // show addEvent popup
  addEventPopup(eventModel: any) {
    eventModel['eventId'] = '';
    if (this.clickedRoom) {
      eventModel.room_id = this.clickedRoom.id;
    }
    const obj = {
      isDetail: false,
      eventModel: eventModel,
      isAPICallError: false,
      checkValidate: true,
      rooms: this.rooms
    };
    this.dialogService.showEventModal('Add Event', 'Add', null, null, null,  'Close', obj)
      .subscribe(res => {
        if (res.buttonName === BUTTON_NAME.OK) {
          const createdEventModel = Object.assign(new CreatedEventSettings(), res.payload.eventModel);
          createdEventModel.repeat_rule = res.payload.rrule;
          this.sharedValueService.waitingApiResponse.next(true);
          this.eventService.postCreateEvent(createdEventModel).subscribe((response: AllEventsSetting) => {
            this.notifierService.notify('success', response.message ? response.message : 'Added successful event!');
            this.sharedValueService.httpStatus.next(true);
            this.sharedValueService.newEventSubject.next(response.data[0].id);
            this.originalListEvents = [...this.originalListEvents, ...this.convertEvents(response.data)];
            // filter Event by room
            this.filterEventsByRoom(this.clickedRoom);
          }, error => {
            const msg = error.error.message ? error.error.message : 'Error occurred!';
            this.notifierService.notify('error', msg);
            this.sharedValueService.httpStatus.next(false);
          });
        }
      });
  }

  eventDrop(model: any) {
    const startTime = moment(model.event.start).clone().subtract(model.duration.asMinutes(), 'minutes')
      .format('YYYY-MM-DD HH:mm').toString();
    this.updateEvent(model, startTime);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/home/home.component.ts